import { FC } from 'react'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { Box, Button, Grid, IconButton, Tooltip } from '@mui/material'

import { AppLoader } from '@components/AppLoader'

type GeneralButtonsProps = {
  cancelText: string
  saveText: string
  onCancel: () => void
  onSave: () => void
  saveDisabled?: boolean
  cancelDisabled?: boolean
  onTogglePreviewVisibility?: () => void
  isPreviewVisible?: boolean
  isLoading?: boolean
}

export const GeneralButtons: FC<GeneralButtonsProps> = ({
  cancelText,
  onCancel,
  onSave,
  saveText,
  saveDisabled,
  cancelDisabled,
  onTogglePreviewVisibility,
  isPreviewVisible = true,
  isLoading,
}) => (
  <Box pr={1} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    {onTogglePreviewVisibility && (
      <Tooltip title={isPreviewVisible ? 'Скрыть превью' : 'Показать превью'}>
        <IconButton size='small' sx={{ mr: 1 }} onClick={onTogglePreviewVisibility}>
          {isPreviewVisible ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </Tooltip>
    )}

    <Grid container flexWrap='nowrap' gap='15px'>
      <Grid item>
        <Button disabled={cancelDisabled} variant='outlined' onClick={onCancel}>
          {cancelText}
        </Button>
      </Grid>
      <Grid item>
        <Button disabled={saveDisabled} variant='contained' onClick={onSave}>
          {saveText}
          {isLoading && <AppLoader size='14px' sx={{ pl: 1 }} />}
        </Button>
      </Grid>
    </Grid>
  </Box>
)
